import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    title: {
      fontWeight: 700,
      fontSize: '20px',
      textAlign: 'center',
    },
    subTitle: {
      fontWeight: 400,
      fontSize: '16px',
      textAlign: 'center',

    },
    closeIcon: {
      position: 'absolute',
      right: '15px',
      top: '15px',
      cursor: 'pointer',
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
    }
  }
))
